import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import { useRouter } from 'next/router';
import React from 'react';
import ZendeskLink from '../Zendesk/ZendeskLink';

//build a re-usable Accordion components, that leverages the AccordionSection component. And receives a FAQ mappings array as a prop.

const FaqAccordion: React.FC<{
  faq: {
    question: string;
    answer: string;
    disabled?: boolean;
  }[];
}> = ({ faq }) => {
  const router = useRouter();

  //we use the path do define keys, since they should be unique accross the app, so a q + a wouldn't cut it
  //if we show the same FAQ in different pages
  const path = router.pathname;
  return (
    <Grid
      sx={{
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '90%',
      }}
      container
      spacing={3}
    >
      <Grid
        sx={{
          textAlign: 'left',
          margin: 'auto',
        }}
      >
        {faq.map((q) => {
          return (
            <AccordionSection
              key={q.question + q.answer + path}
              question={q.question}
              answer={q.answer}
              disabled={!!q.disabled}
            />
          );
        })}
      </Grid>
      <Grid>
        <Typography>Need more information?</Typography>
        <ZendeskLink />
      </Grid>
    </Grid>
  );
};

export default FaqAccordion;

// helper component to render the Accordion sections
const AccordionSection: React.FC<{
  question: string;
  answer: string;
  disabled: boolean;
}> = ({ question, answer, disabled }) => {
  return (
    <Accordion
      disableGutters
      sx={{
        paddingTop: '1rem',
        paddingBottom: '1rem',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />} disabled={disabled}>
        <Typography variant="body1">{question}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body1">{answer}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};
